import SettingsExpertTeamModule from './settings-expert-team.module'

export default SettingsExpertTeamModule
